import { Routes } from '@angular/router';
import { UnsavedChangesGuard } from './unsaved-changes.guard';

/**
 * Utility function to apply the UnsavedChangesGuard to all routes.
 * @param routes Route array to be modified
 * @returns Route array with the guard applied
 */
export function applyUnsavedChangesGuard(routes: Routes): Routes {
  return routes.map(route => {
    if (route.canDeactivate) {
      return route;
    }

    const routeWithGuard = { ...route, canDeactivate: [UnsavedChangesGuard] };

    if (routeWithGuard.children) {
      routeWithGuard.children = applyUnsavedChangesGuard(routeWithGuard.children);
    }

    return routeWithGuard;
  });
}
